export default "__VITE_ASSET__fJX7ZX76__"